import React, { useEffect, useState } from 'react';
import '../styles/MarketMarquee.css';

const MarketMarquee = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchCryptoData = async () => {
      try {
        const res = await fetch(
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=30&page=1&sparkline=false'
        );
        const data = await res.json();

        const formatted = data.map(coin => ({
          name: coin.name,
          ticker: coin.symbol.toUpperCase(),
          price: coin.current_price,
          percentChange: coin.price_change_percentage_24h?.toFixed(2) || '0.00',
        }));

        setItems(formatted);
      } catch (err) {
        console.error('Error fetching crypto data:', err);
      }
    };

    fetchCryptoData();
  }, []);

  const loopItems = [...items, ...items]; // duplicate for continuous scroll

  return (
    <div className="market-marquee-container">
      <div className="market-marquee">
        {loopItems.map((item, index) => (
          <div key={index} className="marquee-card">
            <div className="stock-name">
              {item.name}{' '}
              <span className={parseFloat(item.percentChange) >= 0 ? 'green' : 'red'}>
                ({item.percentChange}%)
              </span>
            </div>
            <div className="stock-price">
              {item.ticker} | ${item.price?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketMarquee;